export default __webpack_public_path__ + "static/media/profile.185d0254.png";